import {getIp} from './getIp'

const getIPFromAIQIYI = async () => {
    try {
        const ip = await getIp();
        const response = await fetch(`https://mesh.if.iqiyi.com/aid/ip/info?version=1.1.1&ip=${ip}`);
        const {code, msg, data} = await response.json();
        if(code == 0 && msg == 'success' && data.cityCN) {
            return {
                ip: ip,
                country: data.countryCN || '',
                province: data.provinceCN || '',
                city: data.cityCN || '',
                area:data.countyCN || '',
                isp: data.ispCN || '',
                latitude: data.latitude,
                longitude:  data.longitude
            }
        }
    } catch (error) {
        console.error("Error fetching IP from aiqiyi", error);
    }
};

export { getIPFromAIQIYI };